import routerOptions0 from "D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher_f924d39af8663cb94184647430147332/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}